import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import React, { createContext, useEffect, useState } from 'react'; // webpackで実行する場合記載が必要
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Admin from './components/admin/Admin';
import Favorite from './components/Favorite';
import Manage from './components/Manage';
import Home from './components/Home';
import ImageView from './components/ImageView';
import Login from './components/Login';
import Logout from './components/Logout';
import NotFound from './components/NotFound';
import Regist from './components/Regist';
import Search from './components/Search';
import Setting from './components/Setting';
import Upload from './components/upload/Upload';
import User from './components/User';
import Terms from './components/Terms';
import Painter from './components/Painter';
import Post from './components/Post';
import UsePageTracking from './components/UsePageTracking';
import Tag from './components/Tag';
import Edit from './components/Edit';
import Community from './components/Community';
import Random from './components/Random';
import Ranking from './components/Ranking';
import TemporaryPassword from './components/TemporaryPassword';
import Campaign from './components/Campaign';
import RegistSelect from './components/RegistSelect';
import RegistConfirm from './components/RegistConfirm';
import LoginSelect from './components/LoginSelect';
import About from './components/About';
import StampManage from './components/StampManage';
import New from './components/New';
import AIGeneraleImageList from './components/AIGeneraleImageList';
import FollowNew from './components/NewFollow';
import Odai from './components/Odai';
import Events from './components/Events';
import History from './components/History';
import NewUser from './components/NewUser';
import NewFollow from './components/NewFollow';
import Series from './components/Series';
import UploadAudio from './components/upload/UploadAudio';
import Invest from './components/Invest';
import PointHistory from './components/PointHistory';
import Notice from './components/Notice';
import Analyze from './components/Analyze';
import PrivacyPolicy from './components/PrivacyPolicy';
import Guideline from './components/Guideline';
import Event from './components/Event';
import UploadEvent from './components/upload/UploadEvent';
import EventPopup from './components/EventViewPopup';
import EventView from './components/EventView';
import MyEditor from './components/upload/MyEditor';
import UploadText from './components/upload/UploadText';
import Jump from './components/Jump';
import Legal from './components/Legal';
import TextView from './components/TextView';
import Text from './components/Text';
import UploadVideo from './components/upload/UploadVideo';
import Video from './components/Video';
import VideoView from './components/VideoView';
import Creators from './components/Creators';
import Invite from './components/Invite';
import Suspend from './components/Suspend';
import Osusume from './components/Osusume';
import Callback from './components/Callback';
import UserBest from './components/UserBest';
import Company from './components/Company';
import PlanManage from './components/PlanManage';
import ManageBilling from './components/ManageBilling';
import CardRegist from './components/common/CardRegist';
import Payment from './components/Payment';
import Payouts from './components/Payouts';
import ManageAd from './components/ad/ManageAd';
import IDConfirmation from './components/IDConfirmation';
import Similarity from './components/Similarity';
import Coin from './components/Coin'
import RankingOthers from './components/RankingOthers';
import Chat from './components/Chat';
import GenerateUnlimit from './components/GenerateUnlimit';
import SearchUsers from './components/SearchUsers';
import UploadCharacter from './components/upload/UploadCharacter';
import CharacterView from './components/CharacterView';
import Character from './components/Character';
import SearchCharacters from './components/SearchCharacters';
import CreatorManage from './components/CreatorManage';
import UploadModel from './components/upload/UploadModelOld';
import Status from './components/Status';
import Rewards from './components/Rewards';
import RewardsHistory from './components/RewardsHistory';
import ItemStock from './components/ItemStock';
import AccountDelete from './components/AccountDelete';
import PrivacyPolicyOnly from './components/PrivacyPolicyOnly';
import TermsOnly from './components/TermsOnly';
import AudioView from './components/AudioView';
import Shop from './components/common/Shop';
import TextToSpeechInterface from './components/generate/TextToSpeechInterface';
import ChatInterface from './components/generate/ChatInterface';
import MonetizationLP from './components/monetization/MonetizationLP';
import StockDetailPage from './components/stock/StockDetailPage';
import AdvancedInpaintEditor from './components/common/AdvancedInpaintEditor';
import CollabEventPage from './components/CollabEventPage';
import UserProfile from './components/user/UserProfile';
import AlTalkSingle from './components/AlTalkSingle';
import MonetizationBanner from './components/common/MonetizationBanner';
import ImageGenerationUI from './components/generate/ImageGenerationUI';
import SimpleImageGenerator from './components/generate/SimpleImageGenerator';
import SideMenu from './components/common/SideMenu';
import StampEditor from './components/tools/StampEditor';
import UserProfile2 from './components/user/UserProfile2';
import UserProfile3 from './components/user/UserProfile3';
import ModelUploadForm from './components/upload/ModelUploadForm';
import Note from './components/common/Note';
import LandingPage from './components/question/LandingPage';
import ModelSelector from './components/generate/ModelSelector';
import QuestionListPage from './components/question/QuestionListPage';
import ControlNetPoseEditor from './components/generate/ControlNetPoseEditor';
import PaintTool from './components/paint/PaintTool';
import ModelPage from './components/upload/ModelPage';
import CoinPackageList from './components/common/CoinPackageList';
import MonsterBallPost from './components/post/MonsterBallPost';
import AdminPayouts from './components/admin/AdminPayouts';
import ModelListPage from './components/upload/ModelListPage';
import AIVideoGenerator from './components/upload/AIVideoGenerator';
import ImageGenerationDialogTest from './components/generate/ImageGenerationDialogTest';
import CalendarMemoTool from './components/tools/CalendarMemoTool';
import AffiliateRewardDashboard from './components/AffiliateRewardDashboard';

export const SearchList = createContext()
export const LoginInfo = createContext()
export const LanguageCtx = createContext()
export const NoticeList = createContext()
export const Iobserver = createContext()

function App() {
  console.log('🚀 App component is initializing...');
  
  // ローディング画面を削除（バックアップ処理）
  useEffect(() => {
    console.log('📱 App component mounted, removing loading screen...');
    
    const removeLoadingScreen = () => {
      const loader = document.getElementById('initial-loader');
      if (loader) {
        console.log('✅ Loading screen found in App useEffect, removing...');
        loader.classList.add('fade-out');
        setTimeout(() => {
          loader.remove();
          console.log('✅ Loading screen removed in App useEffect!');
        }, 500);
      } else {
        console.log('ℹ️ Loading screen already removed or not found in App useEffect');
      }
    };
    
    // 少し遅延させて確実に削除
    const timer = setTimeout(removeLoadingScreen, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  // 画像遅延ロード
  const options = {
    root: null,
    rootMargin: "1200px",
    threshold: 0.05
  }
  const observer = new IntersectionObserver((entries,observer)=>{
      entries.forEach(entry => {
          if(entry.intersectionRatio > 0){
              const imgEl = entry.target
              imgEl.src = imgEl.dataset.src
              observer.unobserve(entry.target)
            }
      })
  }, options);

  const [searchResultList,setSearchResultList] = useState([])
  const [searchPage,setSearchPage] = useState(1)
  const [loginInfo,setLoginInfo] = useState([])
  const [language,setLanguage] = useState([])
  const [noticeList,setNoticeList] = useState([])

  useEffect(() => {
    if(window.location.host === "www.ourt-ai.work"){
      window.location.href = "https://ourt-ai.work/"
    }
  },[])

  console.log('📱 App component is rendering...');

  return (
    <LoginInfo.Provider value={{loginInfo,setLoginInfo}}>
      <LanguageCtx.Provider value={{language,setLanguage}}>
        <NoticeList.Provider value={{noticeList,setNoticeList}}>
          <SearchList.Provider value={{searchResultList,setSearchResultList,searchPage,setSearchPage}}>
            <Iobserver.Provider value={observer}>
              <Router> 
                <UsePageTracking />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/:general_or_ai" element={<Home />} />
                  <Route path="/siteManage" element={<Admin />} />
                  <Route path="/editor" element={<MyEditor />} />
                  <Route path="/suspend" element={<Suspend />} />
                  <Route path="/callback/:type" element={<Callback />} />
                  <Route path="/osusume" element={<Osusume />} />
                  <Route path="/osusume/:style_of_painting" element={<Osusume />} />
                  <Route path="/osusume/:style_of_painting/:general_or_ai" element={<Osusume />} />
                  <Route path="/osusume/:style_of_painting/:general_or_ai/:tag" element={<Osusume />} />
                  <Route path="/invite/:displayIdOrUserId" element={<Invite />} />
                  <Route path="/generatedHistory/image" element={<AIGeneraleImageList />} />
                  <Route path="/generatedHistory/image/:userId" element={<AIGeneraleImageList />} />
                  <Route path="/" element={<Home />} />
                  <Route path="/creators" element={<Creators />} />
                  <Route path="/event" element={<Event />} />
                  <Route path="/event/:id" element={<EventView />} />
                  <Route path="/text" element={<Text />} />
                  <Route path="/text/:id" element={<TextView />} />
                  <Route path="/video" element={<Video />} />
                  <Route path="/video/:id" element={<VideoView />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/events/:group_id" element={<Events />} />
                  <Route path="/odai" element={<Odai />} />
                  <Route path="/odai/:ym" element={<Odai />} />
                  <Route path="/search/:keyword/:page" element={<Search />} />
                  <Route path="/tag/:tag/:page" element={<Tag />} />
                  <Route path="/community" element={<Community />} />
                  <Route path="/newFollow" element={<NewFollow />} />
                  <Route path="/newFollow/:style_of_painting" element={<NewFollow />} />
                  <Route path="/newFollow/:style_of_painting/:general_or_ai" element={<NewFollow />} />
                  <Route path="/new" element={<New />} />
                  <Route path="/new/:style_of_painting" element={<New />} />
                  <Route path="/new/:style_of_painting/:general_or_ai" element={<New />} />
                  <Route path="/new/:style_of_painting/:general_or_ai/:tag" element={<New />} />
                  <Route path="/newUser" element={<NewUser />} />
                  <Route path="/newUser/:style_of_painting" element={<NewUser />} />
                  <Route path="/newUser/:style_of_painting/:general_or_ai" element={<NewUser />} />
                  <Route path="/random" element={<Random />} />
                  <Route path="/ranking/" element={<Ranking />} />
                  <Route path="/ranking/:style_of_painting/:age_limit/:period/:type/" element={<Ranking />} />
                  <Route path="/ranking/:style_of_painting/:age_limit/:period/:type/:page" element={<Ranking />} />
                  <Route path="/regist-select" element={<RegistSelect />} />
                  <Route path="/regist-confirm" element={<RegistConfirm />} />
                  <Route path="/regist" element={<Regist />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/login-select" element={<LoginSelect />} />
                  <Route path="/logout" element={<Logout />} />
                  <Route path="/temporary_password" element={<TemporaryPassword />} />
                  <Route path="/image/:id" element={<ImageView />} />
                  <Route path="/audio/:id" element={<AudioView />} />
                  <Route path="/manage" element={<Manage />} />
                  <Route path="/manage/:page" element={<Manage />} />
                  <Route path="/favorite" element={<Favorite />} />
                  <Route path="/favorite/:page" element={<Favorite />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/history/:page" element={<History />} />
                  <Route path="/setting" element={<Setting />} />
                  <Route path="/upload" element={<Upload />} />
                  <Route path="/upload/image" element={<Upload />} />
                  <Route path="/upload/image/:generate" element={<Upload />} />
                  <Route path="/upload/text" element={<UploadText />} />
                  <Route path="/upload/audio" element={<UploadAudio />} />
                  <Route path="/upload/video" element={<UploadVideo />} />
                  <Route path="/upload/event" element={<UploadEvent />} />
                  <Route path="/upload/character" element={<UploadCharacter />} />
                  <Route path="/upload/model" element={<ModelUploadForm />} />
                  <Route path="/upload/model/:model_id" element={<ModelUploadForm />} />
                  <Route path="/generate/voice" element={<TextToSpeechInterface />} />
                  <Route path="/generate/text" element={<ChatInterface />} />
                  <Route path="/edit/:id" element={<Edit />} />
                  <Route path="/user/:id" element={<User />} />
                  <Route path="/user/:id/best/:year" element={<UserBest />} />
                  <Route path="/user/:id/:tab" element={<User />} />
                  <Route path="/series/:user_id_or_display_id/" element={<Series />} />
                  <Route path="/series/:user_id_or_display_id/:series_link" element={<Series />} />
                  <Route path="/manage/plan/:id" element={<PlanManage />} />
                  <Route path="/post/:id" element={<Post />} />
                  <Route path="/invest" element={<Invest />} />
                  <Route path="/invest/:stock_code" element={<Invest />} />
                  <Route path="/stockDetail/" element={<StockDetailPage />} />
                  <Route path="/pointHistory" element={<PointHistory />} />
                  <Route path="/painter" element={<Painter />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/legal" element={<Legal />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/guideline" element={<Guideline />} />
                  <Route path="/campaign" element={<Campaign />} />
                  <Route path="/stampManage" element={<StampManage />} />
                  <Route path="/manageBilling" element={<ManageBilling />} />
                  <Route path="/stampManage/:page" element={<StampManage />} />
                  <Route path="/notice" element={<Notice />} />
                  <Route path="/notice/:page" element={<Notice />} />
                  <Route path="/analyze" element={<Analyze />} />
                  <Route path="/analyze/:user_id" element={<Analyze />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/company" element={<Company />} />
                  <Route path="/jump/:url" element={<Jump />} />
                  <Route path="/card" element={<CardRegist />} />
                  <Route path="/manage/payment" element={<Payment />} />
                  <Route path="/manage/payouts" element={<Payouts />} />
                  <Route path="/manage/ad" element={<ManageAd />} />
                  <Route path="/manage/id" element={<IDConfirmation />} />
                  <Route path="/similarity/image/:id" element={<Similarity />} />
                  <Route path="/coin" element={<Coin />} />
                  <Route path="/rankingOthers" element={<RankingOthers />} />
                  <Route path="/chat" element={<Chat />} />
                  <Route path="/generate_unlimit" element={<GenerateUnlimit />} />
                  <Route path="/search_users" element={<SearchUsers />} />
                  <Route path="/search_users/:order" element={<SearchUsers />} />
                  <Route path="/search_users/:order/:page" element={<SearchUsers />} />
                  <Route path="/characterView/:id" element={<CharacterView />} />
                  <Route path="/character/:id" element={<Character />} />
                  <Route path="/search_characters" element={<SearchCharacters />} />
                  <Route path="/creatorManage" element={<CreatorManage />} />
                  <Route path="/status" element={<Status />} />
                  <Route path="/rewards" element={<Rewards />} />
                  <Route path="/rewardsHistory" element={<RewardsHistory />} />
                  <Route path="/itemStock" element={<ItemStock />} />
                  <Route path="/accountDelete" element={<AccountDelete />} />
                  <Route path='/privacyOnly' element={<PrivacyPolicyOnly />} />
                  <Route path='/termsOnly' element={<TermsOnly />} />
                  <Route path='/shop' element={<Shop />} />
                  <Route path='/monetizationLP' element={<MonetizationLP />} />
                  <Route path='/inpaint' element={<AdvancedInpaintEditor />} />
                  <Route path='/collab' element={<CollabEventPage />} />
                  <Route path='/user_profile' element={<UserProfile />} />
                  <Route path='/user_profile2' element={<UserProfile2 />} />
                  <Route path="/user_profile2/:id" element={<UserProfile2 />} />
                  <Route path='/user_profile3' element={<UserProfile3 />} />
                  <Route path="/user_profile3/:id" element={<UserProfile3 />} />
                  <Route path='/aitalk' element={<AlTalkSingle />} />
                  <Route path='/aitalk/:characterId' element={<AlTalkSingle />} />
                  <Route path='/monetizationBanner' element={<MonetizationBanner />} />
                  <Route path='/t2i' element={<ImageGenerationUI />} />
                  <Route path='/generate/image/simple' element={<SimpleImageGenerator />} />
                  <Route path='/side' element={<SideMenu />} />
                  <Route path='/stampEditor' element={<StampEditor />} />
                  <Route path='/note' element={<Note />} />
                  <Route path='/question/lp' element={<LandingPage />} />
                  <Route path='/question/list' element={<QuestionListPage />} />
                  <Route path='/modelSearch' element={<ModelSelector />} />
                  <Route path='/paint' element={<PaintTool />} />
                  <Route path='/model/:model_id' element={<ModelPage />} />
                  <Route path='/model/:model_id/:model_version_id' element={<ModelPage />} />
                  <Route path='/paypal' element={<CoinPackageList />} />
                  <Route path='/new_image' element={<MonsterBallPost />} />
                  <Route path='/admin/payouts' element={<AdminPayouts />} />
                  <Route path='/modelList' element={<ModelListPage />} />
                  <Route path='/generate/video' element={<AIVideoGenerator />} />
                  <Route path='/generated' element={<ImageGenerationDialogTest />} />
                  <Route path='/tools/calendarMemo' element={<CalendarMemoTool />} />
                  <Route path='/affiliate/dashboard' element={<AffiliateRewardDashboard />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Router>
            </Iobserver.Provider>
          </SearchList.Provider>
        </NoticeList.Provider>
      </LanguageCtx.Provider>
    </LoginInfo.Provider>
  );
}

export default App;
